import axios from '@/utils/axios';
import { BaseDataResponse, BaseResponse } from '@/type';
import qs from 'qs';

export enum MpAppStatus {
    已获取,
    已封禁,
    审核中,
    已驳回,
}

export interface MPAApplication {
    mpAppId: string;
    applyReason: string;
    applyUid: string[];
}

export interface MpApp extends MPAApplication {
    mpAppName: string;
    status: MpAppStatus;
    rejectReason: string;
}

export const getMPAppList = (appId: string) =>
    axios.get<
        BaseDataResponse<{
            mpAppList: MpApp[];
        }>
    >('/portal/app/scope/mpPlc/listMpApp', {
        params: {
            appId,
        },
    });

export interface WhiteUser {
    uid: number;
    userName: string;
    userHeadPic: string;
}

export const getMPAppUserWhiteList = (
    appId: string,
    mpAppId: string,
    page: {
        pageNum: number;
        pageSize: number;
    },
) =>
    axios.get<
        BaseDataResponse<{
            total: number;
            uidInfoList: WhiteUser[];
        }>
    >('/portal/app/scope/mpPlc/uidWhiteList', {
        params: {
            appId,
            mpAppId,
            ...page,
        },
    });

export const checkAppId = (appId: string, mpAppId: string) =>
    axios.get<
        BaseDataResponse<{
            appName: string;
            remainBinding: number;
        }>
    >('/portal/app/scope/mpPlc/checkAppId', {
        params: {
            appId,
            mpAppId,
        },
    });

export const checkUId = (appId: string, mpAppId: string, uid: string) =>
    axios.get<BaseResponse>('/portal/app/scope/mpPlc/checkUid', {
        params: {
            appId,
            mpAppId,
            uid,
        },
    });

export interface MPAAuthToken extends MPAApplication {
    appId: string;
    scopeGroupId: number;
}

export const createMPAAuthToken = ({
    appId,
    mpAppId,
    applyUid,
    applyReason,
    scopeGroupId,
}: MPAAuthToken) =>
    axios.post<BaseDataResponse<{ preApplyId: string }>>(
        '/portal/app/scope/mpPlc/preApply',
        qs.stringify({
            appId,
            mpAppId,
            applyUid: applyUid.join(','),
            applyReason,
            scopeGroupId,
        }),
    );

export const applyMPA = ({
    appId,
    mpAppId,
    applyUid,
    applyReason,
    preApplyId,
    scopeGroupId,
}: MPAAuthToken & { preApplyId: string }) =>
    axios.post<BaseResponse>(
        '/portal/app/scope/mpPlc/apply',
        qs.stringify({
            appId,
            mpAppId,
            applyUid: applyUid.join(','),
            applyReason,
            preApplyId,
            scopeGroupId,
        }),
    );

export const revokeMPA = (appId: string, mpAppId: string) =>
    axios.post<BaseResponse>(
        '/portal/app/scope/mpPlc/revoke',
        qs.stringify({
            appId,
            mpAppId,
        }),
    );

// export const getMPAWhiteList = (appId: string, mpAppId: string) =>
//     axios.get<BaseResponse>('/portal/app/scope/mpPlc/uidWhiteList', {
//         params: {
//             appId,
//             mpAppId,
//         },
//     });
